(function() {
    if (document.querySelector('.ctabox--team') || document.querySelector('.ctabox--contact-us')) {
        let resizeTimeout;
    
        function updateElements() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const windowWidth = window.innerWidth;
                const teamBoxes = document.querySelectorAll('.ctabox--team');
                const contactBoxes = document.querySelectorAll('.ctabox--contact-us');
                const conind = document.querySelector('.ctabox__conind');
    
                // --- WĄTEK 1: Dla ctabox--team i jego elementów ---
                if (teamBoxes.length) {
                    if (windowWidth >= 992) {
                        teamBoxes.forEach(teamBox => {
                            const textPart = teamBox.querySelector('.ctabox__part--text');
                            if (!textPart) return;
    
                            const textPartStyle = window.getComputedStyle(textPart);
                            const paddingBottom = parseFloat(textPartStyle.paddingBottom);
    
                            const button = textPart.querySelector('.btnbox__btn');
                            if (!button) return;
    
                            const buttonRect = button.getBoundingClientRect();
                            const buttonHalfHeight = buttonRect.height / 2;
    
                            const totalHeight = paddingBottom + buttonHalfHeight + 1;
    
                            // Znajdź wszystkie elementy ctabox__person-info wewnątrz ctabox--team i ustaw ich wysokość oraz dodaj klasę active
                            const personInfoElements = teamBox.querySelectorAll('.ctabox__person-info');
                            personInfoElements.forEach(personInfo => {
                                requestAnimationFrame(() => {
                                    personInfo.style.height = totalHeight + 'px';
                                    personInfo.classList.add('ctabox__person-info--active');
                                });
                            });
    
                            // Ustaw bottom na ctabox__conind, jeśli istnieje
                            if (conind) {
                                requestAnimationFrame(() => {
                                    conind.removeAttribute('style');
                                    conind.style.bottom = totalHeight + 'px';
                                    conind.classList.add('ctabox__conind--active');
                                });
                            }
                        });
                    } else {
                        teamBoxes.forEach(teamBox => {
                            const personInfoElements = teamBox.querySelectorAll('.ctabox__person-info');
                            personInfoElements.forEach(personInfo => {
                                requestAnimationFrame(() => {
                                    personInfo.removeAttribute('style');
                                });
                            });
    
                            const pane = teamBox.querySelector('.ctabox__pane');
    
                            if (pane && conind) {
                                const paneHeight = pane.getBoundingClientRect().height;
    
                                personInfoElements.forEach(personInfo => {
                                    const personInfoHeight = personInfo.getBoundingClientRect().height;
                                    const topValue = paneHeight - personInfoHeight;
    
                                    requestAnimationFrame(() => {
                                        conind.removeAttribute('style');
                                        conind.style.top = topValue + 'px';
                                        conind.classList.add('ctabox__conind--active');
                                    });
                                });
                            }
                        });
                    }
                }
    
                // --- WĄTEK 2: Dla ctabox--contact-us ---
                if (contactBoxes.length) {
                    if (windowWidth >= 992) {
                        contactBoxes.forEach(contactBox => {
                            const textPart = contactBox.querySelector('.ctabox__part--text');
                            if (!textPart) return;
    
                            const textPartStyle = window.getComputedStyle(textPart);
                            const paddingBottom = parseFloat(textPartStyle.paddingBottom);
    
                            const button = textPart.querySelector('.btnbox__btn');
                            if (!button) return;
    
                            const buttonRect = button.getBoundingClientRect();
                            const buttonHalfHeight = buttonRect.height / 2;
    
                            const totalHeight = paddingBottom + buttonHalfHeight + 1;
    
                            // Znajdź wszystkie elementy ctabox__person-info wewnątrz ctabox--contact-us i ustaw ich wysokość oraz dodaj klasę active
                            const personInfoElements = contactBox.querySelectorAll('.ctabox__person-info');
                            personInfoElements.forEach(personInfo => {
                                requestAnimationFrame(() => {
                                    personInfo.style.height = totalHeight + 'px';
                                    personInfo.classList.add('ctabox__person-info--active');
                                });
                            });
                        });
                    } else {
                        contactBoxes.forEach(contactBox => {
                            const personInfoElements = contactBox.querySelectorAll('.ctabox__person-info');
                            personInfoElements.forEach(personInfo => {
                                requestAnimationFrame(() => {
                                    personInfo.removeAttribute('style');
                                });
                            });
                        });
                    }
                }
    
            }, 150); // Czas debounce w milisekundach
        }
    
        // Nasłuchiwanie zdarzeń
        window.addEventListener('load', updateElements);
        window.addEventListener('resize', updateElements);
    }    
})();